/** Une page d'une liste déjà chargée, avec la page réellement affichée. */
export type Paginated<T> = {
  rows: T[]
  /** Page affichée : celle demandée, ramenée dans les bornes de la liste. */
  page: number
  total: number
}

/**
 * Découpe une liste chargée en entier côté client (#198).
 *
 * La page demandée est ramenée sur la dernière page existante : supprimer le
 * seul élément de la dernière page, ou un filtre qui réduit la liste sans
 * passer par `resetPage`, ne laisse jamais un tableau vide avec des résultats
 * ailleurs. Le calcul vit ici plutôt que dans un effet qui corrigerait la page
 * après coup : l'écran ne peint jamais la page hors bornes.
 */
export function paginate<T>(rows: readonly T[], page: number, pageSize: number): Paginated<T> {
  const lastPage = Math.max(1, Math.ceil(rows.length / pageSize))
  const shown = Math.min(Math.max(page, 1), lastPage)
  const start = (shown - 1) * pageSize
  return { rows: rows.slice(start, start + pageSize), page: shown, total: rows.length }
}
